/**
 * ChatHeader - Header with connection status and actions
 */

interface ChatHeaderProps {
  title?: string;
  connectionState: "connecting" | "connected" | "disconnected" | "error";
  onClose?: () => void;
  onMinimize?: () => void;
  className?: string;
}

const statusConfig = {
  connecting: { label: "Connecting...", color: "text-yellow-500", icon: "⟳" },
  connected: { label: "Connected", color: "text-green-500", icon: "●" },
  disconnected: { label: "Disconnected", color: "text-gray-500", icon: "○" },
  error: { label: "Connection error", color: "text-red-500", icon: "!" },
};

export function ChatHeader({
  title = "Chat",
  connectionState,
  onClose,
  onMinimize,
  className = "",
}: ChatHeaderProps) {
  const status = statusConfig[connectionState];

  return (
    <div className={`flex items-center justify-between px-4 py-3 border-b border-border bg-card ${className}`}>
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2">
          <span className="font-semibold text-foreground">{title}</span>
          <span className={`text-xs ${status.color} flex items-center gap-1`}>
            <span className={connectionState === "connecting" ? "animate-spin" : ""}>
              {status.icon}
            </span>
            {status.label}
          </span>
        </div>
      </div>
      <div className="flex items-center gap-1">
        {onMinimize && (
          <button
            onClick={onMinimize}
            className="p-1.5 rounded hover:bg-muted transition-colors"
            title="Minimize"
          >
            <svg className="w-4 h-4 text-muted-foreground" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 12H4" />
            </svg>
          </button>
        )}
        {onClose && (
          <button
            onClick={onClose}
            className="p-1.5 rounded hover:bg-muted transition-colors"
            title="Close"
          >
            <svg className="w-4 h-4 text-muted-foreground" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
}
